/**
 * Settings > Pricing tab hooks — see src/queries/webhooks.js for the
 * template this follows.
 */
import { useMutation } from "@tanstack/react-query";
import { request, ReqMethods } from "../lib/apiClient";

const { GET, PUT } = ReqMethods;

// PricingPlanCard.jsx's handleUpgradeClick fires this from a button click
// (not on mount), so it stays a manually-triggered mutation despite being a
// GET — same "on-demand GET" reasoning as webhooks.js's
// useWebhookConfigSecret. (billing.js's usePaymentInfo covers the same
// endpoint for the Billing tab's on-mount read; kept separate here since
// this call site is imperative, not a query.)
export function usePaymentInfoByAgencyId() {
  return useMutation({
    mutationFn: ({ agency_id, customer_id }) =>
      request(GET, `/subscriptions/agency/${agency_id}/${customer_id}`),
  });
}

// Shared by UpgradePlanModal.jsx and Downgrade.jsx — same endpoint and
// payload shape, only `subscription_type` ("upgrade"/"downgrade") differs,
// so callers pass it as part of the mutate-argument payload.
export function useUpgradeSubscription() {
  return useMutation({
    mutationFn: (payload) => request(PUT, "/subscriptions/upgrade-subscription", { payload }),
  });
}

// add-payment/StripeForm's free-SaaS auto-provision step — attaches the
// plan's default assistants to the account. PUT /assistant — distinct from
// queries/agents.js's assistant hooks, which cover a different endpoint.
export function useUpdateAssistant() {
  return useMutation({
    /** @param {Record<string, any>} payload */
    mutationFn: (payload) => request(PUT, "/assistant", { payload }),
  });
}

// add-payment/StripeForm's "Apply" voucher-code button.
export function useApplyCoupon() {
  return useMutation({
    /** @param {Record<string, any>} payload */
    mutationFn: (payload) => request(PUT, "/coupons/apply", { payload }),
  });
}
